//libs
import { useContext, useCallback } from 'react';
import classNames from 'classnames';

//images
import EtmLogoWebp from '../images/partners/etm-logo.webp';
import EtmLogoPng from '../images/partners/etm-logo.png';
import RusSvetLogoWebp from '../images/partners/rus-svet-logo.webp';
import RusSvetLogoPng from '../images/partners/rus-svet-logo.png';
import ElkomLogoWebp from '../images/partners/elkom-logo.webp';
import ElkomLogoPng from '../images/partners/elkom-logo.png';
import FavoritLogoWebp from '../images/partners/favorit-logo.webp';
import FavoritLogoPng from '../images/partners/favorit-logo.png';
import ToledoLogoWebp from '../images/partners/toledo-logo.webp';
import ToledoLogoPng from '../images/partners/toledo-logo.png';
import ElevelLogoWebp from '../images/partners/elevel-logo.webp';
import ElevelLogoPng from '../images/partners/elevel-logo.png';
import DirectLogoWebp from '../images/partners/direct-logo.webp';
import DirectLogoPng from '../images/partners/direct-logo.png';
import EnergoLogoWebp from '../images/partners/energo-logo.webp';
import EnergoLogoPng from '../images/partners/energo-logo.png';
import ForumElectroLogoWebp from '../images/partners/forum-electro-logo.webp';
import ForumElectroLogoPng from '../images/partners/forum-electro-logo.png';
//import LindexLogoPng from '../images/partners/lindex.png';
import KrasnodarelektroLogoWebp from '../images/partners/Krasnodarelektro.webp';
import KrasnodarelektroLogoPng from '../images/partners/Krasnodarelektro.png';

//components
import Picture from '../../../picture';

//context
import { StoresContext } from '../../../../App';

export type PartnerItem = {
    id: string;
    name: string;
    logoWebp: string;
    logoFallback: string;
    searchTerms: string[];
};

const PARTNERS: PartnerItem[] = [
    { id: 'etm', name: 'ЭТМ', logoWebp: EtmLogoWebp, logoFallback: EtmLogoPng, searchTerms: ['этм', 'etm'] },
    { id: 'rus-svet', name: 'Русский Свет', logoWebp: RusSvetLogoWebp, logoFallback: RusSvetLogoPng, searchTerms: ['русский свет'] },
    { id: 'elkom', name: 'ЭЛКОМ ЭЛЕКТРО', logoWebp: ElkomLogoWebp, logoFallback: ElkomLogoPng, searchTerms: ['элком-электро', 'элком'] },
    { id: 'favorit', name: 'Фаворит электро', logoWebp: FavoritLogoWebp, logoFallback: FavoritLogoPng, searchTerms: ['фаворит-электро'] },
    { id: 'toledo', name: 'Толедо', logoWebp: ToledoLogoWebp, logoFallback: ToledoLogoPng, searchTerms: ['толедо', 'toledo'] },
    { id: 'elevel', name: 'elevel', logoWebp: ElevelLogoWebp, logoFallback: ElevelLogoPng, searchTerms: ['элевел', 'elevel'] },
    { id: 'direct', name: 'DIRECT ELECTRIC', logoWebp: DirectLogoWebp, logoFallback: DirectLogoPng, searchTerms: ['директ', 'электрик'] },
    { id: 'energo', name: 'ENERGO РЕСУРС', logoWebp: EnergoLogoWebp, logoFallback: EnergoLogoPng, searchTerms: ['энергоресурс', 'энерго ресурс'] },
    { id: 'forum', name: 'ФОРУМЭЛЕКТРО', logoWebp: ForumElectroLogoWebp, logoFallback: ForumElectroLogoPng, searchTerms: ['форум электро', 'форумэлектро'] },
    //{ id: 'lindex', name: 'Lindex', logoWebp: LindexLogoPng, logoFallback: LindexLogoPng, searchTerms: ['lindex', 'линдекс'] },
    { id: 'krasnodarelektro', name: 'Краснодарэлектро', logoWebp: KrasnodarelektroLogoWebp, logoFallback: KrasnodarelektroLogoPng, searchTerms: ['krasnodarelektro', 'краснодарэлектро'] },
];

function arraysEqual(itemA: string[], itemB: string[]): boolean {
    if (itemA.length !== itemB.length) return false;
    return itemA.every((item, index) => item.toLowerCase() === itemB[index].toLowerCase());
}

export default function DistributorOfficesBlock() {
    const { featureSearch, setFeatureSearch } = useContext(StoresContext);

    const handlePartnerClick = useCallback(
        (searchTerms: string[]) => {
            const isSelected = arraysEqual(featureSearch, searchTerms);
            setFeatureSearch(isSelected ? [] : searchTerms);
        },
        [featureSearch, setFeatureSearch]
    );

    return (
        <div className="distributor-offices-block">
            <h2 className="distributor-offices-block__title">ОФИСЫ ПРОДАЖ ДИСТРИБЬЮТОРОВ</h2>
            <div className="distributor-offices-block__grid">
                {PARTNERS.map((partner) => {
                    const isActive = featureSearch.length > 0 && arraysEqual(featureSearch, partner.searchTerms);
                    return (
                        <button
                            key={partner.id}
                            type="button"
                            className={classNames(
                                'distributor-offices-block__card',
                                isActive && 'distributor-offices-block__card--active'
                            )}
                            onClick={() => handlePartnerClick(partner.searchTerms)}
                        >
                            <Picture
                                webp={partner.logoWebp}
                                fallback={partner.logoFallback}
                                alt=""
                                className="distributor-offices-block__card-logo"
                            />
                        </button>
                    );
                })}
            </div>
        </div>
    );
}
